var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('i',{staticClass:"el-icon-star-off",staticStyle:{"cursor":"pointer"},on:{"click":_vm.navTo}})])
}
var staticRenderFns = []

export { render, staticRenderFns }